/**
 * CallCentreLookupsService
 * Lookups (signed in) and the caller portal's anonymous settings.
 * Route: callcentre/api/callcentre/lookups* and callcentre/api/callcentre/public/settings
 */
import { BaseService } from '../base/BaseService';
import { unwrapCallCentreResponse as unwrap, callCentreListOrEmpty as listOrEmpty } from './unwrapCallCentreResponse';
/** Call Centre lookups + public settings. */
export class CallCentreLookupsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CallCentreLookupsService.DEFAULT_SERVICE_PATH,
            basePath: CallCentreLookupsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/callcentre/lookups (signed in): every lookup the console and portal need, in one call. */
    async getLookups() {
        return unwrap(await this.getLookupsRaw(), 'Call centre lookups not found');
    }
    getLookupsRaw() {
        return this.http.get(this.buildUrl('lookups'));
    }
    /** GET api/callcentre/lookups/ministries (signed in): ministries for referral campaigns and ministry owners. */
    async getMinistries() {
        return listOrEmpty(await this.getMinistriesRaw());
    }
    getMinistriesRaw() {
        return this.http.get(this.buildUrl('lookups/ministries'));
    }
    /** GET api/callcentre/public/settings (anonymous): what the portal shows before sign-in. */
    async getPublicSettings() {
        return unwrap(await this.getPublicSettingsRaw(), 'Call centre portal settings not found');
    }
    getPublicSettingsRaw() {
        return this.http.get(this.buildUrl('public/settings'));
    }
}
CallCentreLookupsService.DEFAULT_SERVICE_PATH = 'callcentre';
CallCentreLookupsService.BASE_PATH = 'api/callcentre';
//# sourceMappingURL=CallCentreLookupsService.js.map